import request from '@/utils/request'

class Http {
  constructor() {
    this.request = request
  }
}

export default Http
